export default "__VITE_ASSET__DmJ$j1cb__"